<template>
	<router-view/>
</template>